import { cssVar } from '@chakra-ui/react';

const $bg = cssVar('tooltip-bg');
const $arrowBg = cssVar('popper-arrow-bg');

export default {
  Tooltip: {
    baseStyle: {
      [$bg.variable]: `white`,
      bg: [$bg.reference],
      [$arrowBg.variable]: [$bg.reference],
      background: 'white',
      color: 'primary.text',
      fontWeight: 'light',
      lineHeight: 4,
      padding: 2,
      borderRadius: '2px',
      boxShadow: '0px 8px 18px rgba(27, 34, 33, 0.15)',
    },
    sizes: {},
    variants: {
      gray: {
        [$bg.variable]: `gray.50`,
        bg: [$bg.reference],
        [$arrowBg.variable]: [$bg.reference],
        color: 'gray.800',
        fontWeight: 'light',
      },
      darkGray: {
        [$arrowBg.variable]: [$bg.reference],
        color: 'white',
        fontWeight: 'light',
        background: '#505655',
        p: {
          color: 'white',
        },
      },
    },
  },
};
